export const textErrors = [
    {
        code: "default",
        title: "Ha ocurrido un error",
    },
    {
        code: "ERRNUMRELINGRESO",
        title: "Relación de Ingreso (RI) incorrecta",
    },
    {
        code: "VIDA-TRANSACCION-006",
        title: "Relación de Ingreso (RI) usada anteriormente",
    },
    {
        code: "ERRNUMRELINGRESONUMID",
        title: "Relación de Ingreso (RI) no pertenece al cliente",
    },
    {
        code: "VIDA-TRANSACCION-005",
        title: "Relación de Ingreso (RI) no corresponde al monto de la prima",
    },
    {
        code: "ERRNUMOBLIGACION",
        title: "Número de obligación (NO) incorrecta"
    }
]